import { STATUS_CLASSES, STATUS_LABELS } from "../phone_statuses.config";

/** Обновляет отображение статуса телефона в интерфейсе
 * @param {number | string} id - ID телефона
 * @param {string | number} status - Новый статус
 * @param {string | null} reservedFor - Значение поля "зарезервировано за"
 * @returns {void}
 */
export function updatePhoneStatusUI(id, status, reservedFor = null) {
  const statusEl = document.querySelector(`#phone-status-${id}`);

  if (statusEl) {
    statusEl.textContent = STATUS_LABELS[status];
    statusEl.className = STATUS_CLASSES[status];
    statusEl.classList.remove("active");
  }

  const dropdown = document.querySelector(`#phone-status-dropdown-${id}`);

  if (dropdown) {
    dropdown.innerHTML = "";
  }

  if (reservedFor !== null) {
    const reservedEl = document.querySelector(`#phone-reserved-${id}`);

    if (reservedEl) {
      reservedEl.textContent = reservedFor;
    }
  }
}
